/** VUEX module for coupon management **/
import responseNotification from '../lib/responseNotification.js'

import {createCoupon, getCoupons, updateCoupon, deleteCoupon, deliverCoupon, getActiveCoupon} from '../lib/api/calls';

export default {
  namespaced: true,
  state: {
    coupons: []
  },
  mutations: {
    setCoupons (state, coupons) {
      state.coupons = coupons
    }
  },
  actions: {
    load ({commit}) {
      return getCoupons().then(coupons => {
        commit('setCoupons', coupons)
        return coupons
      })
    },
    create (context, payload) {
      createCoupon(payload).then((response) => {
        responseNotification(context, response, 'Coupon Created!')
        context.dispatch('load')
      })
    },
    update (context, {id, payload}) {
      updateCoupon(id, payload).then((response) => {
        responseNotification(context, response, 'Coupon updated!')
        context.dispatch('load')
      })
    },
    delete (context, id) {
      deleteCoupon(id).then((response) => {
        responseNotification(context, response, 'Coupon deleted!')
        context.dispatch('load')
      })
    },
    deliver (context, {id, email}) {
      deliverCoupon(id, email).then((response) => {
        if (!response.error) {
          responseNotification(context, response, 'Coupon delivered!')
        }
      })
    },
    getActive (context, token) {
      return getActiveCoupon(token).then((coupon) => {
        return coupon
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/coupons.js